module.exports = __webpack_public_path__ + "static/media/avatar.cc412727.svg";